import React, { FC } from "react"
import { FeedbackBlockWrapper, FeedbackBlockTitle } from "./styles"

export interface FeedbackBlockProps {
  outcomeidentifier?: string
  identifier?: string
  showhide?: string
  correct?: boolean
  title?: string
  groupMode?: boolean
  className?: string
  children?: React.ReactNode
  accessibilityAttr?: Record<string, string>
}

export const FeedbackBlock: FC<FeedbackBlockProps> = props => {
  const {
    title,
    groupMode = false,
    correct,
    className,
    children,
    accessibilityAttr = {}
  } = props

  const titleText = title ?? (correct ? "Correct" : "Incorrect")
  const hasTitle = Boolean(title?.trim())
  const hasChildren = React.Children.toArray(children).some(child =>
    typeof child === "string" ? child.trim().length > 0 : Boolean(child)
  )

  if (!hasTitle && !hasChildren) {
    return null
  }

  return (
    <FeedbackBlockWrapper
      className={className}
      groupMode={groupMode}
      correct={correct}
      {...accessibilityAttr}
    >
      <FeedbackBlockTitle groupMode={groupMode} correct={correct}>
        {titleText}
      </FeedbackBlockTitle>
      {children}
    </FeedbackBlockWrapper>
  )
}
